import { v as bvVar } from 'bv';

import BaseCaptchaService from './base_captcha_service';
import CustomCaptchaService from './custom_captcha_service';
import GoogleCaptchaService from './google_captcha_service';
import HCaptchaCaptchaService from './hcaptcha_service';
import InvisibleHCaptchaService from './invisible_hcaptcha_service';

const captchaStrategy = bvVar('captchaStrategy');

const Service = {
  custom_solution: CustomCaptchaService,
  disabled: BaseCaptchaService,
  google_recaptcha_v3: GoogleCaptchaService,
  hcaptcha: HCaptchaCaptchaService,
  invisible_hcaptcha: InvisibleHCaptchaService,
}[captchaStrategy];

export const isHCaptcha = bvVar('captchaStrategy') === 'hcaptcha';

export const isInvisibleHCaptcha = bvVar('captchaStrategy') === 'invisible_hcaptcha';

export const loginCaptchaService = Service ? new Service() : null;

export const captchaService = isHCaptcha || isInvisibleHCaptcha
  ? new CustomCaptchaService() : loginCaptchaService;

export const captchaServices = captchaService !== loginCaptchaService
  ? [captchaService, loginCaptchaService]
  : [captchaService];
